var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttachmentGrey(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2948 7.36678L8.16816 13.4934C7.4176 14.244 6.39962 14.6657 5.33816 14.6657C4.27671 14.6657 3.25872 14.244 2.50816 13.4934C1.7576 12.7429 1.33594 11.7249 1.33594 10.6634C1.33594 9.60199 1.7576 8.58401 2.50816 7.83344L8.63483 1.70678C9.1352 1.2064 9.81386 0.925293 10.5215 0.925293C11.2291 0.925293 11.9078 1.2064 12.4082 1.70678C12.9085 2.20715 13.1896 2.88581 13.1896 3.59344C13.1896 4.30108 12.9085 4.97973 12.4082 5.48011L6.27483 11.6068C6.02464 11.857 5.68531 11.9975 5.3315 11.9975C4.97768 11.9975 4.63835 11.857 4.38816 11.6068C4.13797 11.3566 3.99742 11.0173 3.99742 10.6634C3.99742 10.3096 4.13797 9.9703 4.38816 9.72011L10.0482 4.06678",
    stroke: "#97A6A5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentGrey);
export default __webpack_public_path__ + "static/media/attachmentGrey.4d513d874f45c6302941164db267250a.svg";
export { ForwardRef as ReactComponent };